import React from "react";
import Header from "../../Common/Header";
import "./useMentorQuestions";
import useMentorQuestions from "./useMentorQuestions";
export default (props) => {
  const { onBlurInput, resultData, navigateAnswerQuestion, createQuestion } =
    useMentorQuestions();
  return (
    <div className="hiring-process-dashboard">
      <Header />
      <div className="bg-grey-3 py-2">
        <div className="container d-flex justify-content-between align-items-center">
          <h2 className="py-3">Mentor Questions </h2>
        </div>
        {resultData ? (
          <div className="job-detail mt-5 bg-grey-5 px-3">
            <div className="top bg-grey-2 py-3 px-4 mx-n3">
              <h3 className="font-weight-medium">Question Created</h3>
            </div>
            <button
              className="btn btn-primary"
              onClick={() => navigateAnswerQuestion()}
            >
              Answer Question
            </button>
          </div>
        ) : (
          <div className="container">
            <div className="job-detail mt-5 bg-grey-5 px-3">
              <div className="top bg-grey-2 py-3 px-4 mx-n3">
                <h3 className="font-weight-medium">Create Questions</h3>
              </div>
              <div className="row">
                <div className="col-lg-9">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="form-group my-3">
                        <p className="font-weight-medium">
                          <span className="text-danger">* </span>Enter Coding
                          Question
                        </p>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Coding Question"
                          onBlur={(e) => onBlurInput(e)}
                          name="question_coding"
                        />
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="form-group my-3">
                        <p className="font-weight-medium">
                          <span className="text-danger">* </span>Enter Question
                          Description
                        </p>
                        <textarea
                          className="form-control h-auto"
                          placeholder="Enter Question Description"
                          rows="4"
                          onBlur={(e) => onBlurInput(e)}
                          name="description"
                        ></textarea>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group my-3">
                        <p className="font-weight-medium">
                          <span className="text-danger">* </span>Enter Sample
                          Input
                        </p>
                        <textarea
                          className="form-control h-auto"
                          placeholder="Enter Sample Input"
                          rows="4"
                          onBlur={(e) => onBlurInput(e)}
                          name="sample_input"
                        ></textarea>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group my-3">
                        <p className="font-weight-medium">
                          <span className="text-danger">* </span>Enter Sample
                          Output
                        </p>
                        <textarea
                          className="form-control h-auto"
                          placeholder="Enter Sample Output"
                          rows="4"
                          onBlur={(e) => onBlurInput(e)}
                          name="sample_output"
                        ></textarea>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group my-3">
                        <p className="font-weight-medium">
                          <span className="text-danger">* </span>Enter Expected
                          Input
                        </p>
                        <textarea
                          className="form-control h-auto"
                          placeholder="Enter Expected Input"
                          rows="4"
                          onBlur={(e) => onBlurInput(e)}
                          name="expected_input"
                        ></textarea>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group my-3">
                        <p className="font-weight-medium">
                          <span className="text-danger">* </span>Enter Expected
                          Output
                        </p>
                        <textarea
                          className="form-control h-auto"
                          placeholder="Enter Expected Output"
                          rows="4"
                          onBlur={(e) => onBlurInput(e)}
                          name="expected_output"
                        ></textarea>
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="form-group my-3">
                        <p className="font-weight-medium">
                          <span className="text-danger">* </span>Set Time Limit
                          (in mins)
                        </p>
                        <input
                          type="number"
                          className="form-control"
                          placeholder="Set Time Limit (in mins)"
                          onBlur={(e) => onBlurInput(e)}
                          name="time_limit"
                        />
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="form-group my-3">
                        {!resultData ? (
                          <>
                            <button
                              className="btn btn-primary"
                              onClick={() => createQuestion()}
                            >
                              Submit
                            </button>
                          </>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
